"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const styles_1 = require("../../styles");
const Flex_1 = tslib_1.__importDefault(require("../Elements/Flex"));
const calendarUtils_1 = require("./helpers/calendarUtils");
const defaultProps = {};
const Container = (0, styled_components_1.default)(Flex_1.default) ``;
const Title = (0, styled_components_1.default)(Flex_1.default) `
  user-select: none;
  font-weight: bold;
  font-size: 1rem;
`;
const Button = (0, styled_components_1.default)(Flex_1.default) `
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: #f2f4f5;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;
`;
const Label = (0, styled_components_1.default)(Flex_1.default) `
  color: ${props => (props.isHighlight ? styles_1.Colors.Danger : '#899da6')};
  min-width: 2.3rem;
  min-height: 2.3rem;
`;
const Icon = ({ isNext }) => (react_1.default.createElement("svg", { width: "8", height: "12", viewBox: "0 0 8 12", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("g", { fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" },
        react_1.default.createElement("g", { transform: "translate(-12 -10)", stroke: "#899DA6", strokeWidth: "2" },
            react_1.default.createElement("g", { transform: isNext ? 'translate(8 8)' : 'matrix(-1 0 0 1 24 8)' },
                react_1.default.createElement("polyline", { transform: "rotate(-90 8.3 8)", points: "12.8 5.6 8.3 10.4 3.8 5.6" }))))));
const Header = ({ value, onPrevClick, onNextClick, weekStartsOn, highlightsOn, }) => {
    const labels = (0, calendarUtils_1.weekBuilder)({ weekStartsOn });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Container, { marginBottom: "1rem" },
            react_1.default.createElement(Button, { onClick: onPrevClick },
                react_1.default.createElement(Icon, null)),
            react_1.default.createElement(Title, { flex: "1", justifyContent: "center", alignItems: "center" }, `${calendarUtils_1.DateFormat.MMM[value.getMonth()]}, ${value.getFullYear()}`),
            react_1.default.createElement(Button, { onClick: onNextClick },
                react_1.default.createElement(Icon, { isNext: true }))),
        react_1.default.createElement(Container, null, labels.map(label => (react_1.default.createElement(Label, { flex: "1", key: `label-${label}`, justifyContent: "center", alignItems: "center", isHighlight: highlightsOn.includes(label) }, calendarUtils_1.DateFormat.ddd[label]))))));
};
Header.defaultProps = defaultProps;
exports.default = Header;
